import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MixedLoyaltyQuery, FGBTranslationLoader, FGBMissingTranslationHandler } from '@fgb/core';
import { map } from 'rxjs/operators';
import { OwlCarouselSettings } from '@fgb/portal-component-library/src/lib/shared/utilities';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { MixedLoyaltyItemModule } from '@fgb/portal-component-library/src/lib/loyalty/mixed-loyalty/mixed-loyalty-item';
import { RouterModule } from '@angular/router';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@fgb/core';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@angular/router';
import * as ɵngcc4 from 'ngx-owl-carousel-o';
import * as ɵngcc5 from '@fgb/portal-component-library/src/lib/loyalty/mixed-loyalty/mixed-loyalty-item';
import * as ɵngcc6 from '@ngx-translate/core';

function FeaturedRewardsComponent_ng_container_0_ng_container_1_ng_container_14_ng_container_2_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fgbcl-mixed-loyalty-item", 12);
} if (rf & 2) {
    const item_r7 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r8 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵproperty("item", item_r7)("ignoreLink", ctx_r8.isDragging);
} }
function FeaturedRewardsComponent_ng_container_0_ng_container_1_ng_container_14_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, FeaturedRewardsComponent_ng_container_0_ng_container_1_ng_container_14_ng_container_2_ng_template_1_Template, 1, 2, "ng-template", 11);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("width", 300);
} }
function FeaturedRewardsComponent_ng_container_0_ng_container_1_ng_container_14_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "owl-carousel-o", 9);
    ɵngcc0.ɵɵlistener("dragging", function FeaturedRewardsComponent_ng_container_0_ng_container_1_ng_container_14_Template_owl_carousel_o_dragging_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(3); return ctx_r10.isDragging = $event.dragging; });
    ɵngcc0.ɵɵtemplate(2, FeaturedRewardsComponent_ng_container_0_ng_container_1_ng_container_14_ng_container_2_Template, 2, 1, "ng-container", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const mixedLoyaltyItems_r1 = ɵngcc0.ɵɵnextContext(2).ngIf;
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("options", ctx_r3.customOptions);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", mixedLoyaltyItems_r1);
} }
function FeaturedRewardsComponent_ng_container_0_ng_container_1_ng_template_15_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 14);
    ɵngcc0.ɵɵelement(2, "fgbcl-mixed-loyalty-item", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r15 = ctx.$implicit;
    const ctx_r13 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("item", item_r15)("ignoreLink", ctx_r13.isDragging);
} }
function FeaturedRewardsComponent_ng_container_0_ng_container_1_ng_template_15_ng_container_2_ng_container_2_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fgbcl-mixed-loyalty-item", 12);
} if (rf & 2) {
    const item_r17 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r18 = ɵngcc0.ɵɵnextContext(5);
    ɵngcc0.ɵɵproperty("item", item_r17)("ignoreLink", ctx_r18.isDragging);
} }
function FeaturedRewardsComponent_ng_container_0_ng_container_1_ng_template_15_ng_container_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, FeaturedRewardsComponent_ng_container_0_ng_container_1_ng_template_15_ng_container_2_ng_container_2_ng_template_1_Template, 1, 2, "ng-template", 11);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("width", 300);
} }
function FeaturedRewardsComponent_ng_container_0_ng_container_1_ng_template_15_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "owl-carousel-o", 15);
    ɵngcc0.ɵɵlistener("dragging", function FeaturedRewardsComponent_ng_container_0_ng_container_1_ng_template_15_ng_container_2_Template_owl_carousel_o_dragging_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r20 = ɵngcc0.ɵɵnextContext(4); return ctx_r20.isDragging = $event.dragging; });
    ɵngcc0.ɵɵtemplate(2, FeaturedRewardsComponent_ng_container_0_ng_container_1_ng_template_15_ng_container_2_ng_container_2_Template, 2, 1, "ng-container", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const mixedLoyaltyItems_r1 = ɵngcc0.ɵɵnextContext(3).ngIf;
    const ctx_r14 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("options", ctx_r14.customOptions);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", mixedLoyaltyItems_r1);
} }
function FeaturedRewardsComponent_ng_container_0_ng_container_1_ng_template_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵtemplate(1, FeaturedRewardsComponent_ng_container_0_ng_container_1_ng_template_15_ng_container_1_Template, 3, 2, "ng-container", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(2, FeaturedRewardsComponent_ng_container_0_ng_container_1_ng_template_15_ng_container_2_Template, 3, 2, "ng-container", 0);
} if (rf & 2) {
    const mixedLoyaltyItems_r1 = ɵngcc0.ɵɵnextContext(2).ngIf;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", mixedLoyaltyItems_r1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", mixedLoyaltyItems_r1 == null ? null : mixedLoyaltyItems_r1.length);
} }
const _c0 = function () { return ["/rewards"]; };
function FeaturedRewardsComponent_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "div", 2);
    ɵngcc0.ɵɵelementStart(3, "div");
    ɵngcc0.ɵɵelementStart(4, "div", 3);
    ɵngcc0.ɵɵelementStart(5, "h5", 4);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵpipe(7, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "a", 5);
    ɵngcc0.ɵɵelementStart(9, "span");
    ɵngcc0.ɵɵtext(10);
    ɵngcc0.ɵɵpipe(11, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "span", 6);
    ɵngcc0.ɵɵtext(13, "arrow_forward_ios");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(14, FeaturedRewardsComponent_ng_container_0_ng_container_1_ng_container_14_Template, 3, 2, "ng-container", 7);
    ɵngcc0.ɵɵtemplate(15, FeaturedRewardsComponent_ng_container_0_ng_container_1_ng_template_15_Template, 3, 2, "ng-template", null, 8, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r4 = ɵngcc0.ɵɵreference(16);
    const mixedLoyaltyItems_r1 = ɵngcc0.ɵɵnextContext().ngIf;
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(7, 5, "home.page.featured.rewards.title"), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("routerLink", ɵngcc0.ɵɵpureFunction0(9, _c0));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(11, 7, "featured.rewards.show.all"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", (mixedLoyaltyItems_r1 == null ? null : mixedLoyaltyItems_r1.length) > 3)("ngIfElse", _r4);
} }
function FeaturedRewardsComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, FeaturedRewardsComponent_ng_container_0_ng_container_1_Template, 17, 10, "ng-container", 0);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const mixedLoyaltyItems_r1 = ctx.ngIf;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", mixedLoyaltyItems_r1.length);
} }
class FeaturedRewardsComponent {
    constructor(mixedLoyaltyService) {
        this.mixedLoyaltyService = mixedLoyaltyService;
        this.isDragging = false;
        this.customOptions = {
            margin: OwlCarouselSettings.Margin,
            autoWidth: true,
            pullDrag: false,
            autoplay: OwlCarouselSettings.Autoplay,
            autoplayTimeout: OwlCarouselSettings.AutoplayTimeout,
            autoplaySpeed: OwlCarouselSettings.AutoplaySpeed,
            navSpeed: 700,
            navText: ['', ''],
            responsive: {
                0: { items: 1 },
                540: { items: 2 },
                740: { items: 3 },
            },
        };
    }
    ngOnInit() {
        this.mixedLoyaltyItems$ = this.mixedLoyaltyService
            .selectFavouriteMixedLoyaltyItems()
            .pipe(map((items) => items.slice(0, this.take)));
    }
}
FeaturedRewardsComponent.ɵfac = function FeaturedRewardsComponent_Factory(t) { return new (t || FeaturedRewardsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.MixedLoyaltyQuery)); };
FeaturedRewardsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FeaturedRewardsComponent, selectors: [["fgbcl-featured-rewards"]], inputs: { take: "take" }, decls: 2, vars: 3, consts: [[4, "ngIf"], [1, "featured-rewards-bg", "d-flex"], [1, "container", "my-auto", "px-0"], [1, "d-flex", "flex-row", "justify-content-between", "align-items-center", "mt-4", "mb-2"], [1, "featured-rewards-heading", "mb-0"], [1, "featured-rewards-show-all", "text-nowrap", "d-flex", "align-items-center", 3, "routerLink"], [1, "icon", "material-icons"], [4, "ngIf", "ngIfElse"], ["nonCarousel", ""], [3, "options", "dragging"], [4, "ngFor", "ngForOf"], ["carouselSlide", "", 3, "width"], [3, "item", "ignoreLink"], [1, "d-flex", "flex-row", "non-carousel-alignment"], [1, "col-lg-4", "pt-2", "pr-2", "pl-1", "d-lg-block", "d-none"], [1, "d-lg-none", "d-block", 3, "options", "dragging"]], template: function FeaturedRewardsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, FeaturedRewardsComponent_ng_container_0_Template, 2, 1, "ng-container", 0);
        ɵngcc0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 1, ctx.mixedLoyaltyItems$));
    } }, directives: [ɵngcc2.NgIf, ɵngcc3.RouterLinkWithHref, ɵngcc4.CarouselComponent, ɵngcc2.NgForOf, ɵngcc4.CarouselSlideDirective, ɵngcc5.MixedLoyaltyItemComponent], pipes: [ɵngcc2.AsyncPipe, ɵngcc6.TranslatePipe], styles: [".material-icons[_ngcontent-%COMP%]{font-size:1rem}"] });
FeaturedRewardsComponent.ctorParameters = () => [
    { type: MixedLoyaltyQuery }
];
FeaturedRewardsComponent.propDecorators = {
    take: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FeaturedRewardsComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-featured-rewards',
                template: "<ng-container *ngIf=\"mixedLoyaltyItems$ | async as mixedLoyaltyItems\">\r\n  <ng-container *ngIf=\"mixedLoyaltyItems.length\">\r\n    <div class=\"featured-rewards-bg d-flex\">\r\n      <div class=\"container my-auto px-0\">\r\n        <div>\r\n          <div class=\"d-flex flex-row justify-content-between align-items-center mt-4 mb-2\">\r\n            <h5 class=\"featured-rewards-heading mb-0\">\r\n              {{ 'home.page.featured.rewards.title' | translate }}\r\n            </h5>\r\n            <a class=\"featured-rewards-show-all text-nowrap d-flex align-items-center\" [routerLink]=\"['/rewards']\">\r\n              <span>{{ 'featured.rewards.show.all' | translate }}</span>\r\n              <span class=\"icon material-icons\">arrow_forward_ios</span>\r\n            </a>\r\n          </div>\r\n          <!--Carousel if items > 3-->\r\n          <ng-container *ngIf=\"mixedLoyaltyItems?.length > 3; else nonCarousel\">\r\n            <owl-carousel-o [options]=\"customOptions\" (dragging)=\"isDragging = $event.dragging\">\r\n              <ng-container *ngFor=\"let item of mixedLoyaltyItems\">\r\n                <ng-template [width]=\"300\" carouselSlide>\r\n                  <fgbcl-mixed-loyalty-item [item]=\"item\" [ignoreLink]=\"isDragging\"></fgbcl-mixed-loyalty-item>\r\n                </ng-template>\r\n              </ng-container>\r\n            </owl-carousel-o>\r\n          </ng-container>\r\n          <ng-template #nonCarousel>\r\n            <!--No carousel in desktop-->\r\n            <div class=\"d-flex flex-row non-carousel-alignment\">\r\n              <ng-container *ngFor=\"let item of mixedLoyaltyItems\">\r\n                <div class=\"col-lg-4 pt-2 pr-2 pl-1 d-lg-block d-none\">\r\n                  <fgbcl-mixed-loyalty-item [item]=\"item\" [ignoreLink]=\"isDragging\"></fgbcl-mixed-loyalty-item>\r\n                </div>\r\n              </ng-container>\r\n            </div>\r\n            <!--Carousel in mobile-->\r\n            <ng-container *ngIf=\"mixedLoyaltyItems?.length\">\r\n              <owl-carousel-o [options]=\"customOptions\" (dragging)=\"isDragging = $event.dragging\" class=\"d-lg-none d-block\">\r\n                <ng-container *ngFor=\"let item of mixedLoyaltyItems\">\r\n                  <ng-template [width]=\"300\" carouselSlide>\r\n                    <fgbcl-mixed-loyalty-item [item]=\"item\" [ignoreLink]=\"isDragging\"></fgbcl-mixed-loyalty-item>\r\n                  </ng-template>\r\n                </ng-container>\r\n              </owl-carousel-o>\r\n            </ng-container>\r\n          </ng-template>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n</ng-container>\r\n",
                styles: [".material-icons{font-size:1rem}"]
            }]
    }], function () { return [{ type: ɵngcc1.MixedLoyaltyQuery }]; }, { take: [{
            type: Input
        }] }); })();

class FeaturedRewardsModule {
}
FeaturedRewardsModule.ɵfac = function FeaturedRewardsModule_Factory(t) { return new (t || FeaturedRewardsModule)(); };
FeaturedRewardsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: FeaturedRewardsModule });
FeaturedRewardsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            CarouselModule,
            MixedLoyaltyItemModule,
            RouterModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: FGBTranslationLoader,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: FGBMissingTranslationHandler
                }
            }),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FeaturedRewardsModule, { declarations: function () { return [FeaturedRewardsComponent]; }, imports: function () { return [CommonModule,
        CarouselModule,
        MixedLoyaltyItemModule,
        RouterModule, ɵngcc6.TranslateModule]; }, exports: function () { return [FeaturedRewardsComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FeaturedRewardsModule, [{
        type: NgModule,
        args: [{
                declarations: [FeaturedRewardsComponent],
                imports: [
                    CommonModule,
                    CarouselModule,
                    MixedLoyaltyItemModule,
                    RouterModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useClass: FGBTranslationLoader,
                            deps: [HttpClient]
                        },
                        missingTranslationHandler: {
                            provide: MissingTranslationHandler,
                            useClass: FGBMissingTranslationHandler
                        }
                    }),
                ],
                exports: [FeaturedRewardsComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { FeaturedRewardsComponent, FeaturedRewardsModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-loyalty-featured-rewards.js.map